<template>
  <div class="dutyInfo">
    <div class="mainCon">
      <div class="title">值班时间</div>

      <el-table :data="tableData">
        <el-table-column style="width: 10%"></el-table-column>
        <el-table-column style="width: 10%">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.dayTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="周一" style="width: 10%;">
          <template slot-scope="scope">
            <div slot="reference" class="name-wrapper">
              <el-tag size="medium" v-show="timeHandle(scope.row.time, '1')">{{
                scope.row.dutyType
              }}</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="周二" style="width: 10%">
          <template slot-scope="scope">
            <div slot="reference" class="name-wrapper">
              <el-tag size="medium" v-show="timeHandle(scope.row.time, '2')">{{
                scope.row.dutyType
              }}</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="周三" style="width: 10%">
          <template slot-scope="scope">
            <div slot="reference" class="name-wrapper">
              <el-tag size="medium" v-show="timeHandle(scope.row.time, '3')">{{
                scope.row.dutyType
              }}</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="周四" style="width: 10%">
          <template slot-scope="scope">
            <div slot="reference" class="name-wrapper">
              <el-tag size="medium" v-show="timeHandle(scope.row.time, '4')">{{
                scope.row.dutyType
              }}</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="周五" style="width: 10%">
          <template slot-scope="scope">
            <div slot="reference" class="name-wrapper">
              <el-tag size="medium" v-show="timeHandle(scope.row.time, '5')">{{
                scope.row.dutyType
              }}</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="周六" style="width: 10%">
          <template slot-scope="scope">
            <div slot="reference" class="name-wrapper">
              <el-tag size="medium" v-show="timeHandle(scope.row.time, '6')">{{
                scope.row.dutyType
              }}</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="周日" style="width: 10%">
          <template slot-scope="scope">
            <div slot="reference" class="name-wrapper">
              <el-tag size="medium" v-show="timeHandle(scope.row.time, '7')">{{
                scope.row.dutyType
              }}</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column style="width: 10%"> </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { dutyInfo } from "@/api";
export default {
  data() {
    return {
      tableData: [
        {
          dayTime: "上午",
          dutyType: "值班",
          time: [],
        },
        {
          dayTime: "下午",
          dutyType: "值班",
          time: [],
        },
        {
          dayTime: "晚上",
          dutyType: "值班",
          time: [],
        },
      ],
    };
  },
  methods: {
    handleEdit(index, row) {
      console.log(index, row);
    },
    handleDelete(index, row) {
      console.log(index, row);
    },
    async getDutyInfo() {
      try {
        const params = {};
        let res = await dutyInfo(params);
        if (res.success) {
          let data = res.result[0];
          this.tableData[0].time = this.getDutyData(data.morning.week);
          this.tableData[1].time = this.getDutyData(data.afternoon.week);
          this.tableData[2].time = this.getDutyData(data.night.week);
        }
      } catch (error) {
        console.log(error);
      }
    },
    //数据组装
    getDutyData(data) {
      let array = [];
      for (var i in data) {
        // console.log(data[i])
        if (data[i] == 1) {
          array.push(i);
        }
      }
      console.log(array);
      return array;
    },
    timeHandle(time, cur) {
      var str = time.toString();
      if (str.indexOf(cur) != -1) {
        return true;
      }
    },
  },
  mounted() {
    this.getDutyInfo();
  },
};
</script>
<style lang="scss" scoped>
.name-wrapper{
  margin-left: -10px;
}
.dutyInfo {
  width: 100%;
  margin: 20px;
    box-shadow: 0 2px 12p#ebeef5;
  -webkit-box-shadow:0 2px 12px 0 #ebeef5;
  .mainCon {
    display:flex;
    flex-direction: row;
    padding: 50px;
    border: 1px solid #ddd;
    box-shadow: 0 0 4px #ddd;
    .title {
      font-size: 20px;
      padding: 10px 0;
      margin-top: -30px;
    }
  }
}
</style>